import { render, staticRenderFns } from "./TransitionCheckbox.vue?vue&type=template&id=37533a8e"
import script from "./TransitionCheckbox.vue?vue&type=script&lang=ts"
export * from "./TransitionCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports